var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 31,
    viewBox: "0 0 105 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(-2155 -7546) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M15.5,0,31,35H0Z",
    transform: "translate(7546 -2260)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 11,
    height: 70,
    transform: "translate(7556 -2225)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintArrowRight);
export default __webpack_public_path__ + "static/media/Print-Arrow-Right.3363be06791c09d81e010686054183ff.svg";
export { ForwardRef as ReactComponent };